import { useContext } from 'react'

import { Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import Button from 'Root/App/Button'
import { Context as ShareContext } from 'Root/Contexts/Share'
import { isMatching } from 'lib/breakpoint-helper'
import { copyShareLink } from 'lib/share-callback'

const canUseNavigatorShare = Boolean(
  typeof window !== 'undefined' &&
    window.navigator.share &&
    window.navigator.canShare
)

const CopyCheckoutLink = ({ slug }: { slug: string }) => {
  const { i18n } = useLingui()
  const shareData = useContext(ShareContext)
  const isMobile = isMatching('sm', true)
  const checkoutLink = `/checkout/cc/${slug}`

  const handleCopyLink = copyShareLink(
    canUseNavigatorShare && isMobile && window.navigator.canShare(shareData),
    shareData,
    checkoutLink,
    i18n
  )

  return (
    <span id="copy-checkout-link" className="flex flex-col gap-1 sm:flex-row">
      <span className="w-full px-3 py-5 text-gray-400 border-gray-300 rounded-md shadow-sm form-input">
        {checkoutLink}
      </span>
      <span className="inline-flex gap-1 items-center">
        <Button
          className="w-max bg-gray-100 text-gray-400"
          onClick={handleCopyLink}
          style={{ minHeight: '3.5rem' }}
        >
          <Trans>Copia link</Trans>
        </Button>
      </span>
    </span>
  )
}

export default CopyCheckoutLink
